import { Grid } from "@mui/material";
import React from "react";
import Identite from "./Identite";
import ExperienceProfessionnels from "./ExperienceProfessionnels";
import Etudes from "./Etudes";
import Formations from "./Formations";
import AutreCompetence from "./AutreCompetence";

const MonCV = () => {
  return (
    <Grid container display={"flex"} flexDirection={"row"} mr={2}>
      <Grid item xs={12}>
        {/* <Grid mt={2.5}>
          <Identite />
        </Grid> */}
        <Grid mt={2.5}>
          <ExperienceProfessionnels />
        </Grid>
        <Grid mt={2.5}>
          <Etudes />
        </Grid>
        <Grid mt={2.5}>
          <Formations />
        </Grid>
        <Grid mt={2.5}>
          <AutreCompetence />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MonCV;
